import { makeStyles } from "@material-ui/core/styles";
import React from "react";
import BottomNavBar from "../components/generalComponents/BottomNavBar";
import ConfirmSignUpForm from "../components/login/ConfirmSignUpForm";
import Background from "../images/food_background.jpg";

const useStyles = makeStyles((theme) => ({
  loginView: {
    backgroundImage: `url(${Background})`,
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    width: "100%",
    height: "100%",
  },
}));

export default function ConfirmSignUpView(props) {
  const classes = useStyles();
  return (
    <div className={("pageWrapper", classes.loginView)}>
      <ConfirmSignUpForm />
      <BottomNavBar />
    </div>
  );
}
